export default "/fonts/SofiaSans-100-Thin.woff2?43424fe1e094eb22d2a99ecb76b16d0f";